import { ChevronLeft, ChevronRight } from "lucide-react";
import React, { useState } from "react";
import { ActionIcon, createStyles, Divider, Group, Text } from "@mantine/core";
import { usePagination } from "@mantine/hooks";

type PaginationProps = {
  total: number;
  initialPage: number;
  onChange: (page: number) => void;
};

const useStyle = createStyles(() => ({
  text: {
    height: "16px",
    flexGrow: 0,
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.33,
    letterSpacing: "0.16px",
    textAlign: "left",
    color: "var(--grey-grey-80)",
  },
}));

const Pagination: React.FC<PaginationProps> = ({
  total,
  initialPage,
  onChange,
  // onNext,
  // onPrevious
}) => {
  const pagination = usePagination({ total, initialPage, onChange });
  const [rowsPerPage] = useState<string | null>("20");
  const { classes } = useStyle();

  return (
    <>
      <Divider my="sm" />
      <Group position="apart" spacing="xl">
        <div />
        <Group spacing="xl">
          <Text className={classes.text}>{`
          ${
            pagination.active === 1
              ? 1
              : (pagination.active - 1) * Number(rowsPerPage)
          }-${pagination.active * Number(rowsPerPage)} of ${
            total * Number(rowsPerPage)
          }`}</Text>
          <ActionIcon size="md" onClick={() => pagination.previous()}>
            <ChevronLeft size={18} />
          </ActionIcon>
          <ActionIcon onClick={() => pagination.next()}>
            <ChevronRight size={18} />
          </ActionIcon>
        </Group>
      </Group>
    </>
  );
};

export default Pagination;
